import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const MarketingTools = ({ venue, analytics }) => {
  const [activeTab, setActiveTab] = useState('promotions');
  const [showNewPromotionModal, setShowNewPromotionModal] = useState(false);

  const promotions = [
    {
      id: 1,
      title: 'Happy Hour das Quadras',
      description: 'Desconto de 30% para reservas entre 14h e 16h',
      discount: 30,
      type: 'percentage',
      startDate: '2025-10-20',
      endDate: '2025-11-20',
      status: 'active',
      used: 23,
      revenue: 3450.75
    },
    {
      id: 2,
      title: 'Pacote Fim de Semana',
      description: 'Reserve sábado e domingo com desconto especial',
      discount: 15,
      type: 'percentage',
      startDate: '2025-10-15',
      endDate: '2025-12-15',
      status: 'active',
      used: 12,
      revenue: 2180.40
    }
  ];

  const campaigns = [
    {
      id: 1,
      name: 'Divulgação Local - Outono 2025',
      type: 'local_ads',
      status: 'active',
      budget: 500.00,
      spent: 287.50,
      clicks: 1240,
      conversions: 34,
      revenue: 6800.00
    },
    {
      id: 2,
      name: 'Featured Listing Premium',
      type: 'featured_listing',
      status: 'active',
      budget: 200.00,
      spent: 200.00,
      impressions: 8750,
      clicks: 437,
      bookings: 18
    }
  ];

  const NewPromotionModal = ({ onClose, onSave }) => {
    const [formData, setFormData] = useState({
      title: '',
      description: '',
      discountType: 'percentage',
      discountValue: 0,
      startDate: '',
      endDate: '',
      courts: [],
      minHours: 1,
      maxUses: 100,
      timeRestrictions: false,
      startTime: '06:00',
      endTime: '23:00'
    });

    const handleInputChange = (field, value) => {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    };

    const handleSave = () => {
      onSave?.(formData);
      onClose();
    };

    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
        <div className="bg-card border border-border rounded-lg shadow-elevation-4 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-heading font-bold text-card-foreground">
                Criar Promoção
              </h3>
              <Button
                variant="ghost"
                size="sm"
                onClick={onClose}
                iconName="X"
                iconSize={16}
              />
            </div>

            <div className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Título da Promoção
                  </label>
                  <Input
                    type="text"
                    value={formData?.title}
                    onChange={(e) => handleInputChange('title', e?.target?.value)}
                    placeholder="Ex: Happy Hour das Quadras"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Tipo de Desconto
                  </label>
                  <Select
                    value={formData?.discountType}
                    onChange={(value) => handleInputChange('discountType', value)}
                  >
                    <option value="percentage">Porcentagem (%)</option>
                    <option value="fixed">Valor Fixo (R$)</option>
                  </Select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-muted-foreground mb-2">
                  Descrição
                </label>
                <textarea
                  value={formData?.description}
                  onChange={(e) => handleInputChange('description', e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
                  rows={3}
                  placeholder="Descreva os detalhes da promoção..."
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Valor do Desconto
                  </label>
                  <Input
                    type="number"
                    value={formData?.discountValue}
                    onChange={(e) => handleInputChange('discountValue', parseFloat(e?.target?.value))}
                    min="0"
                    step={formData?.discountType === 'percentage' ? '1' : '0.01'}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Data de Início
                  </label>
                  <Input
                    type="date"
                    value={formData?.startDate}
                    onChange={(e) => handleInputChange('startDate', e?.target?.value)}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Data de Término
                  </label>
                  <Input
                    type="date"
                    value={formData?.endDate}
                    onChange={(e) => handleInputChange('endDate', e?.target?.value)}
                  />
                </div>
              </div>

              <div>
                <div className="flex items-center mb-3">
                  <Checkbox
                    id="timeRestrictions"
                    checked={formData?.timeRestrictions}
                    onChange={(checked) => handleInputChange('timeRestrictions', checked)}
                  />
                  <label htmlFor="timeRestrictions" className="ml-2 text-sm text-card-foreground">
                    Aplicar restrição de horário
                  </label>
                </div>

                {formData?.timeRestrictions && (
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-muted-foreground mb-2">
                        Horário de Início
                      </label>
                      <Input
                        type="time"
                        value={formData?.startTime}
                        onChange={(e) => handleInputChange('startTime', e?.target?.value)}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-muted-foreground mb-2">
                        Horário de Término
                      </label>
                      <Input
                        type="time"
                        value={formData?.endTime}
                        onChange={(e) => handleInputChange('endTime', e?.target?.value)}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Mínimo de Horas
                  </label>
                  <Input
                    type="number"
                    value={formData?.minHours}
                    onChange={(e) => handleInputChange('minHours', parseInt(e?.target?.value))}
                    min="1"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-muted-foreground mb-2">
                    Máximo de Usos
                  </label>
                  <Input
                    type="number"
                    value={formData?.maxUses}
                    onChange={(e) => handleInputChange('maxUses', parseInt(e?.target?.value))}
                    min="1"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-3 pt-4 border-t border-border">
                <Button variant="outline" onClick={onClose}>
                  Cancelar
                </Button>
                <Button variant="default" onClick={handleSave}>
                  Criar Promoção
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderPromotionsTab = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-bold text-card-foreground">
          Promoções Ativas
        </h3>
        <Button
          variant="default"
          onClick={() => setShowNewPromotionModal(true)}
          iconName="Plus"
          iconPosition="left"
          iconSize={16}
        >
          Nova Promoção
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {promotions?.map((promotion) => (
          <div key={promotion?.id} className="bg-card border border-border rounded-lg shadow-elevation-2 p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h4 className="font-heading font-bold text-card-foreground mb-1">
                  {promotion?.title}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {promotion?.description}
                </p>
              </div>
              <span className="px-2 py-1 text-xs font-medium rounded-full bg-success/10 text-success border border-success/20">
                Ativa
              </span>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="text-center p-3 bg-primary/10 rounded-lg">
                <div className="text-2xl font-heading font-bold text-primary">
                  {promotion?.discount}%
                </div>
                <div className="text-xs text-muted-foreground">Desconto</div>
              </div>
              <div className="text-center p-3 bg-warning/10 rounded-lg">
                <div className="text-2xl font-heading font-bold text-warning">
                  {promotion?.used}
                </div>
                <div className="text-xs text-muted-foreground">Usos</div>
              </div>
            </div>

            <div className="space-y-2 mb-4">
              <div className="flex justify-between text-sm">
                <span className="text-muted-foreground">Período:</span>
                <span className="text-card-foreground">
                  {new Date(promotion?.startDate)?.toLocaleDateString('pt-BR')} - {new Date(promotion?.endDate)?.toLocaleDateString('pt-BR')}
                </span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-muted-foreground">Receita gerada:</span>
                <span className="text-success font-semibold">
                  R$ {promotion?.revenue?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </span>
              </div>
            </div>

            <div className="flex space-x-2">
              <Button variant="outline" size="sm" className="flex-1">
                Editar
              </Button>
              <Button variant="ghost" size="sm" iconName="BarChart3" iconSize={14} />
              <Button variant="ghost" size="sm" iconName="Eye" iconSize={14} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderCampaignsTab = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-bold text-card-foreground">
          Campanhas de Marketing
        </h3>
        <Button variant="default" iconName="Plus" iconPosition="left" iconSize={16}>
          Nova Campanha
        </Button>
      </div>

      <div className="space-y-4">
        {campaigns?.map((campaign) => (
          <div key={campaign?.id} className="bg-card border border-border rounded-lg shadow-elevation-2 p-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h4 className="font-heading font-bold text-card-foreground mb-1">
                  {campaign?.name}
                </h4>
                <div className="flex items-center space-x-2">
                  <span className="px-2 py-1 text-xs font-medium rounded-full bg-primary/10 text-primary border border-primary/20">
                    {campaign?.type === 'local_ads' ? 'Anúncios Locais' : 'Destaque Premium'}
                  </span>
                  <span className="px-2 py-1 text-xs font-medium rounded-full bg-success/10 text-success border border-success/20">
                    Ativa
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
              <div className="text-center p-3 bg-muted/30 rounded-lg">
                <div className="text-lg font-heading font-bold text-card-foreground">
                  R$ {campaign?.spent?.toFixed(2)}
                </div>
                <div className="text-xs text-muted-foreground">
                  de R$ {campaign?.budget?.toFixed(2)}
                </div>
              </div>

              {campaign?.clicks && (
                <div className="text-center p-3 bg-muted/30 rounded-lg">
                  <div className="text-lg font-heading font-bold text-card-foreground">
                    {campaign?.clicks}
                  </div>
                  <div className="text-xs text-muted-foreground">Cliques</div>
                </div>
              )}

              {campaign?.conversions && (
                <div className="text-center p-3 bg-muted/30 rounded-lg">
                  <div className="text-lg font-heading font-bold text-card-foreground">
                    {campaign?.conversions}
                  </div>
                  <div className="text-xs text-muted-foreground">Conversões</div>
                </div>
              )}

              {campaign?.impressions && (
                <div className="text-center p-3 bg-muted/30 rounded-lg">
                  <div className="text-lg font-heading font-bold text-card-foreground">
                    {(campaign?.impressions / 1000)?.toFixed(1)}k
                  </div>
                  <div className="text-xs text-muted-foreground">Impressões</div>
                </div>
              )}

              {campaign?.bookings && (
                <div className="text-center p-3 bg-muted/30 rounded-lg">
                  <div className="text-lg font-heading font-bold text-card-foreground">
                    {campaign?.bookings}
                  </div>
                  <div className="text-xs text-muted-foreground">Reservas</div>
                </div>
              )}
            </div>

            {campaign?.revenue && (
              <div className="p-3 bg-success/10 border border-success/20 rounded-lg mb-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-success">Receita gerada:</span>
                  <span className="text-lg font-semibold text-success">
                    R$ {campaign?.revenue?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </span>
                </div>
                <div className="text-xs text-success/80 mt-1">
                  ROI: {((campaign?.revenue / campaign?.spent - 1) * 100)?.toFixed(0)}%
                </div>
              </div>
            )}

            <div className="w-full bg-muted/30 rounded-full h-2 mb-4">
              <div 
                className="bg-primary h-2 rounded-full transition-all duration-300" 
                style={{ width: `${(campaign?.spent / campaign?.budget) * 100}%` }}
              ></div>
            </div>

            <div className="flex space-x-2">
              <Button variant="outline" size="sm">
                Gerenciar
              </Button>
              <Button variant="ghost" size="sm" iconName="BarChart3" iconSize={14} />
              <Button variant="ghost" size="sm" iconName="Settings" iconSize={14} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderListingTab = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-bold text-card-foreground">
          Destaque na Plataforma
        </h3>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-6">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-warning/10 rounded-lg">
              <Icon name="Star" size={20} className="text-warning" />
            </div>
            <div>
              <h4 className="font-heading font-bold text-card-foreground">
                Destaque Premium
              </h4>
              <p className="text-sm text-muted-foreground">
                Apareça no topo da busca
              </p>
            </div>
          </div>

          <div className="space-y-3 mb-4">
            <div className="flex justify-between">
              <span className="text-sm text-muted-foreground">Status:</span>
              <span className="px-2 py-1 text-xs font-medium rounded-full bg-success/10 text-success border border-success/20">
                Ativo
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-muted-foreground">Investimento mensal:</span>
              <span className="text-sm font-semibold text-card-foreground">R$ 200,00</span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-muted-foreground">Visualizações extras:</span>
              <span className="text-sm font-semibold text-success">+340%</span>
            </div>
          </div>

          <Button variant="outline" size="sm" className="w-full">
            Gerenciar Destaque
          </Button>
        </div>

        <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-6">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-info/10 rounded-lg">
              <Icon name="Image" size={20} className="text-info" />
            </div>
            <div>
              <h4 className="font-heading font-bold text-card-foreground">
                Galeria de Fotos
              </h4>
              <p className="text-sm text-muted-foreground">
                Mostre suas instalações
              </p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 mb-4">
            {[1, 2, 3, 4, 5, 6]?.map((i) => (
              <div key={i} className="aspect-square bg-muted/30 rounded border-2 border-dashed border-muted flex items-center justify-center">
                <Icon name="Plus" size={16} className="text-muted-foreground" />
              </div>
            ))}
          </div>

          <Button variant="outline" size="sm" className="w-full">
            Gerenciar Fotos
          </Button>
        </div>
      </div>

      <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-6">
        <h4 className="font-heading font-bold text-card-foreground mb-4">
          Performance da Listagem
        </h4>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-heading font-bold text-card-foreground">
              2.4k
            </div>
            <div className="text-sm text-muted-foreground">Visualizações</div>
          </div>
          
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-heading font-bold text-card-foreground">
              18%
            </div>
            <div className="text-sm text-muted-foreground">Taxa de cliques</div>
          </div>
          
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-heading font-bold text-card-foreground">
              67
            </div>
            <div className="text-sm text-muted-foreground">Contatos</div>
          </div>
          
          <div className="text-center p-4 bg-muted/30 rounded-lg">
            <div className="text-2xl font-heading font-bold text-card-foreground">
              4.7
            </div>
            <div className="text-sm text-muted-foreground">Avaliação</div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-heading font-bold text-foreground">
            Ferramentas de Marketing
          </h2>
          <p className="text-muted-foreground">
            Promoções, campanhas publicitárias e destaque na plataforma
          </p>
        </div>
      </div>
      {/* Tabs */}
      <div className="border-b border-border">
        <nav className="flex space-x-8">
          {[
            { id: 'promotions', label: 'Promoções', icon: 'Tag' },
            { id: 'campaigns', label: 'Campanhas', icon: 'Megaphone' },
            { id: 'listing', label: 'Destaque', icon: 'Star' }
          ]?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`flex items-center space-x-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === tab?.id
                  ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/50'
              }`}
            >
              <Icon name={tab?.icon} size={16} />
              <span>{tab?.label}</span>
            </button>
          ))}
        </nav>
      </div>
      {/* Tab Content */}
      <div>
        {activeTab === 'promotions' && renderPromotionsTab()}
        {activeTab === 'campaigns' && renderCampaignsTab()}
        {activeTab === 'listing' && renderListingTab()}
      </div>
      {/* New Promotion Modal */}
      <NewPromotionModal
        onClose={() => setShowNewPromotionModal(false)}
        onSave={(data) => {
          console.log('New promotion:', data);
          setShowNewPromotionModal(false);
        }}
      />
    </div>
  );
};

export default MarketingTools;